// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wwuzgbfaruolefovfeqa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3dXpnYmZhcnVvbGVmb3ZmZXFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNTAxODgsImV4cCI6MjA2MzkyNjE4OH0.91MY68EwmS7vPi3MzeILxu46IAIoClvIavXcZPcwM8U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);